export default "__VITE_ASSET__BGqlJZLO__"